var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Channel } from './channel/channel.js';
import { Connection } from './io/index.js';
import { DispatcherImpl } from './message/dispatcher.js';
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    function Client(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.channels = new Map();
        return _this;
    }
    Client.prototype.connect = function () {
        var _this = this;
        if (this.connection) {
            return;
        }
        this.connection = new Connection({
            socketConstructor: function () {
                return new window.WebSocket(_this.endpoint.toString());
            },
            pingFrequency: 60,
            lifeCount: 10,
        });
        this.connection.bind('message', function (message) {
            var _a;
            switch (message.type) {
                case '__ChannelEvent':
                    (_a = _this.channels.get(message.channel)) === null || _a === void 0 ? void 0 : _a.map(function (ch) {
                        ch.emit(message.event, message);
                    });
                    break;
                default:
                    break;
            }
        });
        this.connection.bind('status', function (status) { return _this.emit('status', status); });
        this.connection.open();
    };
    Client.prototype.subscribe = function (channel, onSubscribed, onUnSubscribed) {
        var _a;
        var ch = new Channel(channel);
        var list = (_a = this.channels.get(channel)) !== null && _a !== void 0 ? _a : [];
        list.push(ch);
        this.channels.set(channel, list);
        this.connection.send(JSON.stringify({
            channel: channel,
            service: 'channel',
            appId: this.options.appId,
            action: 'subscribe',
            uuid: ch.uuid,
        }));
        if (onSubscribed) {
            ch.once("__subscribed:".concat(ch.uuid), onSubscribed);
        }
        if (onUnSubscribed) {
            ch.once("__unsubscribed:".concat(ch.uuid), onUnSubscribed);
        }
        return ch;
    };
    Client.prototype.unsubscribe = function (channel) {
        var list = this.channels.get(channel.name);
        if (!list) {
            return;
        }
        var finalList = list.filter(function (ch) { return ch.uuid !== ch.uuid; });
        if (finalList.length === 0) {
            /**
             * no more listener... remove subscription
             */
            this.connection.send(JSON.stringify({
                channel: channel.name,
                service: 'channel',
                appId: this.options.appId,
                action: 'unsubscribe',
                uuid: channel.uuid,
            }));
        }
        this.channels.set(channel.name, finalList);
        channel.emit("__unsubscribed:".concat(channel.uuid));
    };
    Client.prototype.disconnect = function () {
        var _a;
        (_a = this.connection) === null || _a === void 0 ? void 0 : _a.close();
    };
    Object.defineProperty(Client.prototype, "host", {
        get: function () {
            var _a;
            return (_a = this.options.host) !== null && _a !== void 0 ? _a : "webpush.archipro.co.nz/live";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Client.prototype, "endpoint", {
        get: function () {
            var url = new URL("wss://".concat(this.host));
            url.searchParams.append('appId', this.options.appId);
            return url;
        },
        enumerable: false,
        configurable: true
    });
    return Client;
}(DispatcherImpl));
export { Client };
